import { render, staticRenderFns } from "./ModalUsageLimit.vue?vue&type=template&id=6098c4e3&scoped=true&"
import script from "./ModalUsageLimit.vue?vue&type=script&lang=js&"
export * from "./ModalUsageLimit.vue?vue&type=script&lang=js&"
import style0 from "./ModalUsageLimit.vue?vue&type=style&index=0&id=6098c4e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098c4e3",
  null
  
)

export default component.exports